"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", {
  className: "text-primary"
}, "How to Change An Application"), /*#__PURE__*/_react.default.createElement("p", null, "Once you have applied to run a slalom, you can select the My Applications tab. This shows draft entries for the yearbook with action buttons, for example:"), /*#__PURE__*/_react.default.createElement("img", {
  src: "/public/calendar-app-my-applications.jpg",
  className: "img-fluid",
  alt: "Calendar - My Applications Page"
}), /*#__PURE__*/_react.default.createElement("p", null, "The action buttons that you see will depend on the current status of the application, you access rights and the time of year."), /*#__PURE__*/_react.default.createElement("p", null, "The Change button will allow you to update some of the core data eg: change the start date or site (this button will disappear a short while before the ACM"), /*#__PURE__*/_react.default.createElement("p", null, "The Edit Detail button is used for the additional data required for the yearbook entry"));
const myApplications = () => {
  return _ref;
};
var _default = exports.default = myApplications;